"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialManState = void 0;
exports.initialManState = {
    pagination: { current: 1, pageSize: 20, total: 0 },
    filter: {},
    sort: [],
    search: '',
};
//# sourceMappingURL=ManipulationState.js.map